const quickLinks = [
  { label: '最新上线', href: '#latest' },
  { label: '题材分类', href: '#genres' },
  { label: '精选片单', href: '#collections' },
  { label: '蓝光专区', href: '#bluray' },
];

const helpLinks = [
  { label: '排行榜', href: '#charts' },
  { label: '下载指南', href: '#guide' },
  { label: '常见问题', href: '#faq' },
  { label: '回到顶部', href: '#home' },
];

const hotCategories = ['2025新片', '4K蓝光原盘', '高分悬疑', '合家欢动画', '经典修复', '剧集套装'];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-primary-600 text-background-50 flex items-center justify-center">
                <i className="ri-film-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">电影天堂</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 max-w-xs">
              专注最新电影高清资源的聚合与检索，覆盖 2025 新片、蓝光原盘与迅雷磁力链接指引，帮助影迷快速找到心仪影片。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-9 h-9 rounded-md border border-background-300 text-foreground-600 flex items-center justify-center">
                <i className="ri-mail-line"></i>
              </span>
              <span className="w-9 h-9 rounded-md border border-background-300 text-foreground-600 flex items-center justify-center">
                <i className="ri-rss-line"></i>
              </span>
              <span className="w-9 h-9 rounded-md border border-background-300 text-foreground-600 flex items-center justify-center">
                <i className="ri-share-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900">页面导航</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {quickLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900">使用帮助</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {helpLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-foreground-600 hover:text-primary-700 transition-colors cursor-pointer">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-900">热门分类</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {hotCategories.map((c) => (
                <span key={c} className="px-3 py-1.5 rounded-full bg-background-50 border border-background-300 text-xs text-foreground-600">
                  {c}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-foreground-500 leading-relaxed max-w-2xl">
            本站为影片信息聚合与检索演示页面，仅用于展示分类与检索体验，页面内不提供实际下载链接。所有影视作品的版权归其权利人所有，请通过正规渠道观看。
          </p>
          <p className="text-xs text-foreground-500 whitespace-nowrap">© 2025 电影天堂 · 影迷的找片助手</p>
        </div>
      </div>
    </footer>
  );
}